<template>
  <div>
    <my-header></my-header>
    <!-- <el-breadcrumb class="breadcrumb" separator="/">
      <el-breadcrumb-item style="cursor: pointer">考试中心</el-breadcrumb-item>
      <el-breadcrumb-item>考试列表</el-breadcrumb-item>
    </el-breadcrumb>-->
    <div class="swiper">
      <img style="width: 100%; height: 100%" src="../../../static/banner.jpg" alt />
    </div>
    <div class="body_list">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>考试中心</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="test_tag">
        <div class="plain_test">普通考试</div>
      </div>
      <!-- <div style="text-align: center"> -->
      <!-- <span style="color: #009688; font-size: 28px">普通考试</span> -->
      <!-- <span>预约考试</span> -->
      <!-- </div> -->
      <!-- <el-divider></el-divider> -->
      <!-- <el-tabs class="tabsClass" v-model="activeName" @tab-click="handleClick"> -->
      <!-- <el-tab-pane label="普通考试" name="first"> -->
      <div class="noTest" v-if="exerciseList.length == 0">
        <div class="noTest_img">
          <img style="width: 240px; height: 243px" src="../../../static/20210517new/noTest.png" alt />
        </div>
      </div>
      <ul class="main_list" v-else>
        <li class="list_li" v-for="item in exerciseList" :key="item.index">
          <div class="blue_color"></div>
          <div class="main_list_header">{{ item.exerciseName }}</div>
          <div class="main_list_btn">
            <div class="test_tagName">一张试卷</div>
            <div class="test_tagName" style="margin-left: 10px">在线考试</div>
          </div>
          <!-- <el-button
            v-if="item.anyTimeExam == 0"
            style="width: 120px; margin-top: 27px; margin-left: 10px"
            >随时考</el-button
          >-->
          <h3 v-if="item.anyTimeExam == 0" style="color: #666666; text-indent: 12px">开始时间：随时考</h3>
          <h3
            v-if="item.anyTimeExam == 0"
            style="color: #666666; text-indent: 12px; margin-top: 10px"
          >结束时间：随时考</h3>
          <h3
            v-if="item.anyTimeExam == 1"
            style="color: #666666; text-indent: 12px"
          >开始时间：{{ item.examTimeStart }}</h3>
          <h3
            v-if="item.anyTimeExam == 1"
            style="color: #666666; text-indent: 12px; margin-top: 10px"
          >结束时间：{{ item.examTimeEnd }}</h3>
          <!-- <el-divider></el-divider> -->
          <div class="main_list_foot">
            <el-button
              type="primary"
              @click="
                readyTest(
                  item.examNotice,
                  item.isNotice,
                  item.id,
                  item.courseId,
                  item.examTimeStart,
                  item.examTimeEnd,
                  item.anyTimeExam,
                  item.lateDelay,
                  item.passScore,
                  item.score,
                  item.invalid
                )
              "
              plain
              style="width: 215px; height: 35px; margin-top: 20px"
            >开始考试</el-button>
            <!-- <el-button
              type="primary"
              v-else
              @click="lookResult(item.id)"
              plain
              style="margin-top: -10px"
              >查看结果</el-button
            >-->
          </div>
        </li>
      </ul>
      <!-- </el-tab-pane> -->
      <!-- <el-tab-pane label="预约考试" name="second">预约考试</el-tab-pane> -->
      <!-- </el-tabs> -->
    </div>
    <el-pagination
      v-show="total > 0"
      background
      prev-text="上一页"
      next-text="下一页"
      :page-size="queryParams.pageSize"
      :total="total"
      :current-page.sync="queryParams.pageNum"
      @current-change="currentChange"
      layout="total, prev, pager, next"
      style="margin-bottom: 30px; margin-top: 20px"
      align="center"
    ></el-pagination>
    <!-- 考试须知弹窗 -->
    <el-dialog title="考试须知" :visible.sync="dialogVisible" width="50%">
      <p style="color: red; text-align: center; margin-bottom: 20px">请一定要仔细阅读！</p>
      <div class="newsContent" v-html="noticeContent" style="margin-left: 20px">{{ noticeContent }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="beforeGoToTest">确 定</el-button>
      </span>
    </el-dialog>
    <my-footer></my-footer>
  </div>
</template>
<script>
import myHeader from "../../components/header.vue";
import myFooter from "../../components/footer.vue";
import {
  entpExamList,
  exerciseDetailVerification,
  getEntpExamConfigCurrent,
  getEmployeeCourseOverStatus,
  exerciseDetail
} from "@/apiCloud/testList";
import { getEmployeeInformation } from "@/apiCloud/userCenter";
export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      exerciseList: [],
      activeName: "first",
      dialogVisible: false,
      noticeContent: "",
      exerciseId: "",
      courseId: "",
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 12
      },
      nowTime: "",
      timeStart: "",
      timeEnd: "",
      canStartTest: 0,
      canAnyTimeExam: 0,
      canLateDelay: 0,
      passScore: 0,
      score: 0
    };
  },
  created() {
    this.getTestList();
  },
  methods: {
    //准备开始考试
    readyTest(
      examNotice,
      isNotice,
      exerciseId,
      courseId,
      examTimeStart,
      examTimeEnd,
      anyTimeExam,
      lateDelay,
      passScore,
      score,
      invalid
    ) {
      this.nowTime = Date.parse(new Date());
      this.timeStart = Date.parse(new Date(examTimeStart));
      this.timeEnd = Date.parse(new Date(examTimeEnd));
      this.canAnyTimeExam = anyTimeExam;
      this.canLateDelay = lateDelay;
      this.passScore = passScore;
      this.score = score;
      this.invalid = invalid;
      // console.log(anyTimeExam,this.nowTime,this.timeStart)
      if (this.score >= this.passScore && this.invalid ==0) {
        this.$alert("当前考试已合格,不用再次考试。", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return;
      }
      else if(this.score >= this.passScore && this.invalid ==2){
        this.$alert("已完成当前考试，请等待审核。", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return;
      }
      if (anyTimeExam == 0) {
        this.canStartTest = 0;
      } else {
        if (this.nowTime >= this.timeStart) {
          this.canStartTest = 0;         
        } else {
          this.canStartTest = 1;
        }
      }
      this.nextWork(examNotice, isNotice, exerciseId, courseId);
    },
    // 点击判断结果后进行的操作
    nextWork(examNotice, isNotice, exerciseId, courseId) {
      this.exerciseId = exerciseId;
      this.courseId = courseId;
      let data = {
        exerciseId: this.exerciseId,
        courseId: this.courseId
      };
      exerciseDetailVerification(data).then(res => {
        if (res.code == 200) {
          if (isNotice == 0) {
            this.dialogVisible = true;
            this.noticeContent = examNotice;
          } else {
            this.beforeGoToTest();
          }
        } else {
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
            callback: action => {}
          });
        }
      });
    },
    beforeGoToTest() {
      if (this.canStartTest === 1) {
        this.$alert("当前考试未到考试时间,请等待", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
      } else {
        this.goToTest();
      }
    },

    //去往考试页面
    goToTest() {
      if (this.canStartTest == 1) {
        this.$alert("当前考试未到考试时间,请等待", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
      } else {
        let url1 = "employee/getEmployeeInformation";
        getEmployeeInformation({}).then(response => {
          let data = {
            exerciseId: this.exerciseId
          };
          getEntpExamConfigCurrent(data).then(resdata => {
            //判断实名
            if (resdata.data.needRealName == 0) {
              if (!response.data.empIdcardFront) {
                this.$message({
                  message: "请先进行实名认证",
                  type: "warning",
                  duration: "3000"
                });
              } else {
                //判断是否显示结果
                if (resdata.data.resultShow == 0) {
                  if (this.score >= this.passScore) {
                    this.$alert("当前考试已合格,不用再次考试。", "提示", {
                      confirmButtonText: "确定",
                      callback: action => {}
                    });
                  } else {
                    //判断是否学完课程才能学习
                    if (resdata.data.examTimeLimit == 1) {
                      let data = {
                        courseId: this.courseId,
                        empId: response.data.empId
                      };
                      getEmployeeCourseOverStatus(data).then(res => {
                        if (res.data != 1) {
                          this.$message({
                            message: "请先学完课程再进行考试",
                            type: "warning",
                            duration: "3000"
                          });
                        } else {
                          this.routerToTest();
                        }
                      });
                    } else {
                      this.routerToTest();
                    }
                  }
                } else {
                  //判断是否学完课程才能学习
                  if (resdata.data.examTimeLimit == 1) {
                    let data = {
                      courseId: this.courseId,
                      empId: response.data.empId
                    };
                    getEmployeeCourseOverStatus(data).then(res => {
                      if (res.data != 1) {
                        this.$message({
                          message: "请先学完课程再进行考试",
                          type: "warning",
                          duration: "3000"
                        });
                      } else {
                        this.routerToTest();
                      }
                    });
                  } else {
                    this.routerToTest();
                  }
                }
              }
            } else {
              //判断是否学完课程才能学习
              if (resdata.data.examTimeLimit == 1) {
                let data = {
                  courseId: this.courseId,
                  empId: response.data.empId
                };
                getEmployeeCourseOverStatus(data).then(res => {
                  if (res.data != 1) {
                    this.$message({
                      message: "请先学完课程再进行考试",
                      type: "warning",
                      duration: "3000"
                    });
                  } else {
                    this.routerToTest();
                  }
                });
              } else {
                this.routerToTest();
              }
            }
          });
        });
      }
    },
    //跳到考试页面
    routerToTest() {
      let data = {
        id: this.exerciseId
      };
      exerciseDetail(data).then(res => {
        this.passScore = res.data.passScore;
        let testData = {
          exerciseId: this.exerciseId,
          courseId: this.courseId,
          timeStart: this.timeStart * 3 + 123456,
          timeEnd: this.timeEnd * 3 + 123456,
          canAnyTimeExam: this.canAnyTimeExam,
          canLateDelay: this.canLateDelay,
          passScore: res.data.passScore
        };
        localStorage.setItem("testData", JSON.stringify(testData));
        this.$router.push({
          path: "/testDetail"
        });
      });
    },
    currentChange(page) {
      this.queryParams.pageNum = page;
      this.getTestList();
    },
    //查看考试
    lookResult(exerciseId) {
      // if(考了没){
      this.$router.push({
        path: "/testResult",
        query: {
          exerciseId: exerciseId
        }
      });
      // }
    },
    // 获取考试列表
    getTestList() {
      let data = this.queryParams;
      entpExamList(data).then(res => {
        this.exerciseList = res.rows;
        this.total = res.total;
        let timer2 = Date.parse(new Date());
        for (let i = 0; i < this.exerciseList.length; i++) {
          if (this.exerciseList[i].examTimeEnd) {
            // console.log("clh=====2=>",this.exerciseList[i]);
            let timer1 = Date.parse(new Date(this.exerciseList[i].examTimeEnd));
            if (timer1 <= timer2) {
              this.exerciseList[i].canTest = 1;
            } else {
              this.exerciseList[i].canTest = 0;
            }
          } else {
            this.exerciseList[i].canTest = 0;
          }
        }
      });
    },
    //切换考试分类
    handleClick() {}
  }
};
</script>
<style lang="less" src="./testList.less" scoped></style>



// WEBPACK FOOTER //
// src/pages/testList/testList.vue